<template>
  <div class="home_wrap">
    <div
      ref="homeScroll"
      class="home-scroll"
    >
      <header class="home-top">
        <div class="brand-box">
          <img
            v-if="app && app.logo"
            class="logo"
            :src="app.logo"
            alt=""
          >
        </div>
        <button
          type="button"
          class="language"
          @click="$router.push('/language')"
        >
          <img
            :src="require('../images/language/' + lang + '.png')"
            alt=""
          >
          <span class="language-code">{{ languageCode }}</span>
          <span class="language-label">{{ languageLabel }}</span>
          <span class="language-arrow" />
        </button>
      </header>

      <van-swipe
        v-if="bannerList.length"
        class="hero-swipe"
        :autoplay="3000"
        lazy-render
      >
        <van-swipe-item
          v-for="(item, index) in bannerList"
          :key="index"
        >
          <img
            :src="getLocalizedImage(item)"
            alt=""
          >
        </van-swipe-item>
      </van-swipe>

      <div
        v-if="notifyStr"
        class="notice-card"
      >
        <van-icon
          name="volume"
          class="notice-icon"
        />
        <div class="notice-text">
          <marquee
            scrollamount="3"
            behavior="scroll"
          >
            {{ notifyStr }}
          </marquee>
        </div>
      </div>

      <section
        v-if="brandItems.length"
        class="brand-panel"
      >
        <button
          v-for="item in brandItems"
          :key="item.id || item.jtitle"
          type="button"
          class="brand-item"
          @click="goItem(item)"
        >
          <span class="brand-logo-box">
            <img
              v-if="item.img"
              :src="item.img"
              alt=""
              @error="hideBrokenImage"
            >
          </span>
          <span class="brand-name">{{ item.jtitle }}</span>
        </button>
      </section>

      <section
        v-if="vipCards.length"
        class="task-panel section-panel"
      >
        <h2 class="section-title">
          {{ $t("index.videoTasks") }}
        </h2>
        <div class="vip-task-list">
          <div
            v-for="(item, index) in vipCards"
            :key="item.id || item.name || index"
            class="vip-task-wrap"
          >
            <button
              type="button"
              class="vip-task-card"
              :class="'vip-task-card-' + index"
              @click="$router.push('/vip')"
            >
              <span class="vip-copy">
                <strong>{{ getVipName(item, index) }}</strong>
                <em>{{ $t("index.singleTaskMinSalary") }}</em>
              </span>
              <span class="vip-amount">{{ getVipAmount(item) }} {{ moneyMark }}</span>
            </button>
            <span
              v-if="index === 0 && vipCards.length > 1"
              class="vs-badge"
            >
              VS
            </span>
          </div>
        </div>
      </section>

      <section
        v-if="cashList.length"
        class="earnings-panel section-panel"
      >
        <h2 class="section-title">
          {{ $t("index.weeklyMusicEarnings") }}
        </h2>
        <div
          class="earnings-viewport"
          :class="{ 'is-static': cashList.length < 5 }"
        >
          <div class="earnings-track">
            <div
              v-for="(item, index) in scrollCashList"
              :key="item.acc + '-' + index"
              class="earning-row"
            >
              <img
                class="earning-avatar"
                :src="item.img"
                alt=""
                @error="hideBrokenImage"
              >
              <div class="earning-copy">
                <strong>{{ $t("index.congratulations") }} {{ item.acc }}</strong>
                <span>{{ $t("index.lastWeeksEarnings") }}</span>
              </div>
              <div class="earning-amount">
                {{ item.money }} {{ moneyMark }}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        v-if="partnerList.length"
        class="partners-panel section-panel"
      >
        <h2 class="section-title">
          {{ $t("index.partners") }}
        </h2>
        <div class="partners-grid">
          <button
            v-for="(item, index) in partnerList"
            :key="item.url || index"
            type="button"
            class="partner-card"
            @click="goPartner(item)"
          >
            <img
              :src="getLocalizedImage(item)"
              alt=""
              @error="hideBrokenImage"
            >
          </button>
        </div>
      </section>
    </div>

    <van-dialog
      v-model="show_tc"
      width="90%"
      :confirm-button-text="$t('utils.confirm')"
    >
      <img
        class="dialog-img"
        src="../images/index/tanchuang.png"
        alt=""
      >
      <div
        class="popup"
        v-html="tc_content"
      />
    </van-dialog>

    <van-dialog
      v-model="noticeDialogShow"
      width="90%"
      class="site-notice-dialog"
      :title="currentNoticeTitle"
      :confirm-button-text="$t('utils.confirm')"
      @confirm="confirmNoticeRead"
    >
  <!--    <div
        v-if="currentNotice && currentNotice.add_time"
        class="site-notice-time"
      >
        {{ currentNotice.add_time }}
      </div> -->
      <div
        class="site-notice-body"
        v-html="currentNoticeContent"
      />
    </van-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import {
  Swipe,
  SwipeItem,
  Icon,
  Dialog
} from "vant";

Vue.use(Icon).use(Dialog);

export default {
  name: "Index",
  components: {
    VanSwipe: Swipe,
    VanSwipeItem: SwipeItem
  },
  data() {
    return {
      lang: this.$i18n.locale || localStorage.getItem("lang") || "zh_cn",
      loading: false,
      randomNumber: 0,
      data: {
        item1: { show: true },
        item2: { show: true },
        item3: { show: true }
      },
      app: {},
      islogin: false,
      isapp: false,
      show_tc: false,
      tc_content: "",
      vip: null,
      vips: [],
      banner: [],
      links: [],
      items: [],
      cashes: [],
      coindatas: null,
      notifyStr: "",
      noticeTimer: null,
      noticeChecking: false,
      noticeDialogShow: false,
      currentNotice: null
    };
  },
  computed: {
    bannerList() {
      return this.banner || [];
    },
    brandItems() {
      return this.items || [];
    },
    vipCards() {
      return (this.vips || []).slice(0, 4);
    },
    cashList() {
      return (this.cashes || []).slice(0, 12);
    },
    scrollCashList() {
      if (!this.cashList.length) {
        return [];
      }
      return this.cashList.length < 5 ? this.cashList : this.cashList.concat(this.cashList);
    },
    partnerList() {
      return this.links || [];
    },
    moneyMark() {
      return localStorage.getItem("moneyMark") || "€";
    },
    languageCode() {
      const codeMap = {
        en_us: "US",
        pt_br: "BR",
        ja_jp: "JP",
        ko_kr: "KR",
        zh_hk: "TW",
        zh_cn: "CN",
        th_th: "ES",
        vi_vn: "AR",
        id_ind: "ID",
        ms_my: "IT"
      };
      return codeMap[this.lang] || this.lang.slice(0, 2).toUpperCase();
    },
    languageLabel() {
      const labelMap = {
        en_us: "English",
        pt_br: "Português",
        ja_jp: "日本語",
        ko_kr: "한국인",
        zh_hk: "繁體中文",
        th_th: "Español",
        vi_vn: "اللغة العربية",
        id_ind: "Indonesia",
        ms_my: "Italiano"
      };
      return labelMap[this.lang] || this.lang;
    },
    currentNoticeTitle() {
      return this.currentNotice && this.currentNotice.title ? this.currentNotice.title : this.$t("notice.message");
    },
    currentNoticeContent() {
      return this.currentNotice && this.currentNotice.content ? this.currentNotice.content : "";
    }
  },
  created() {
    this.$parent.footer("home");
  },
  mounted() {
    if (this.$router.history.current.query.agent) {
      localStorage.setItem("agent", this.$router.history.current.query.agent);
    }
    if (this.$router.history.current.query.isapp) {
      localStorage.setItem("isapp", "true");
    }
    this.islogin = localStorage.getItem("token") != null;
    if (!this.islogin) {
      this.$router.push("/login");
      return;
    }
    this.start();

    this.isapp = localStorage.getItem("isapp") != null;
  },
  beforeDestroy() {
    this.stopNoticePolling();
  },
  methods: {
    getcoinsdata() {
      Fetch("/user/getcoinsdata").then(r => {
        this.coindatas = JSON.parse(r.data);
      });
    },
    download() {
      var downloadurl = document.createElement("A");
      downloadurl.href = this.app.app_link;
      downloadurl.target = "blank";
      downloadurl.click();
    },
    goItem(item) {
      if (item && item.id) {
        this.$router.push("/buy/" + item.id);
      }
    },
    goPartner(item) {
      if (!item || !item.url) {
        return;
      }
      if (/^https?:\/\//i.test(item.url)) {
        window.location.href = item.url;
        return;
      }
      this.$router.push(item.url);
    },
    getLocalizedImage(item) {
      if (!item) {
        return "";
      }
      return item[this.lang] || item.en_us || item.zh_cn || item.zh_hk || "";
    },
    getVipName(item, index) {
      if (item && item.name) {
        return item.name;
      }
      return "VIP" + index;
    },
    getVipAmount(item) {
      const raw = item && (item.rate );
      if (raw === undefined || raw === null || raw === "") {
        return "0";
      }
      return raw;
    },
    hideBrokenImage(event) {
      if (event && event.target) {
        event.target.style.display = "none";
      }
    },
    startNoticePolling() {
      this.stopNoticePolling();
      this.checkUnreadNotice();
      this.noticeTimer = setInterval(() => {
        this.checkUnreadNotice();
      }, 10000);
    },
    stopNoticePolling() {
      if (this.noticeTimer) {
        clearInterval(this.noticeTimer);
        this.noticeTimer = null;
      }
    },
    checkUnreadNotice() {
      if (!this.islogin || this.noticeChecking || this.noticeDialogShow || this.show_tc) {
        return;
      }
      this.noticeChecking = true;
      Fetch("/index/sync", {}, null, false).then(r => {
        var unread = Number(r.data) || 0;
        if (unread <= 0) {
          return null;
        }
        return Fetch("/user/notice", {}, null, false).then(res => {
          var list = res.data && res.data.list ? res.data.list : [];
          var notice = list.find(item => Number(item.uid) !== 0 && Number(item.status) === 0);
          if (notice && !this.noticeDialogShow && !this.show_tc) {
            this.currentNotice = notice;
            this.noticeDialogShow = true;
          }
          return notice;
        });
      }).catch(() => {}).then(() => {
        this.noticeChecking = false;
      });
    },
    confirmNoticeRead() {
      var notice = this.currentNotice;
      this.noticeDialogShow = false;
      this.currentNotice = null;
      if (!notice || !notice.id) {
        return;
      }
      Fetch("/user/notice_view", {
        id: notice.id
      }, null, false).catch(() => {});
    },
    start() {
      Fetch("/index/int").then(r => {
        this.data = r.data;
        this.vip = r.data.vip;
        this.vips = r.data.vips || [];
        this.banner = r.data.banner || [];
        this.links = r.data.links || [];
        this.notifyStr = r.data.notice;
        this.cashes = r.data.cashes || [];
        this.items = r.data.items || [];
        this.randomNumber = Math.floor(Math.random() * (7800 - 6877 + 1)) + 6877;
        this.loading = true;

        if (r.data.popup.show == 1) {
          this.tc_content = r.data.popup.content;
          if (localStorage.getItem("tc") != this.tc_content) {
            localStorage.setItem("tc", this.tc_content);
            this.show_tc = true;
          }
        }
        this.startNoticePolling();
      });

      Fetch("/index/webconfig").then(r => {
        this.app = r.data;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: #111;
  color: #f6f6f6;
  overflow: hidden;
}

.home-scroll {
  height: 100vh;
  overflow-y: auto;
  padding-bottom: 118px;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
}

.home-top {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 18px;
  background: #101010;
  box-sizing: border-box;
}

.brand-box {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 0 0 auto;
}

.logo {
  width: 72px;
  height: 34px;
  max-width: 72px;
  max-height: 34px;
  margin: 0;
  object-fit: contain;
}

.language {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 138px;
  height: 44px;
  padding: 0 12px;
  border: 0;
  border-radius: 22px;
  background: rgba(2, 4, 9, 0.92);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
}

.language img {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.language-code {
  margin-left: 10px;
  color: rgba(255, 255, 255, 0.42);
  font-size: 12px;
  line-height: 1;
  text-transform: uppercase;
}

.language-label {
  max-width: 76px;
  margin-left: 6px;
  overflow: hidden;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.language-arrow {
  width: 0;
  height: 0;
  margin-left: 8px;
  border-top: 6px solid rgba(255, 255, 255, 0.82);
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  flex-shrink: 0;
}

.hero-swipe {
  height: 150px;
  overflow: hidden;
  background: #222;
}

.hero-swipe img {
  display: block;
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.notice-card {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  min-height: 44px;
  margin: -8px 20px 0;
  padding: 0 14px;
  border-radius: 12px;
  background: #242424;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.22);
  box-sizing: border-box;
}

.notice-icon {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 28px;
  color: #fff;
  font-size: 24px;
}

.notice-text {
  min-width: 0;
  flex: 1;
  margin-left: 14px;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
}

.brand-panel {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin: 18px 20px 0;
  padding: 16px 14px;
  border-radius: 12px;
  background: #222;
  box-sizing: border-box;
}

.brand-item {
  display: flex;
  align-items: center;
  min-width: 0;
  height: 74px;
  padding: 12px;
  border: 1px solid #303030;
  background: transparent;
  color: #f6f6f6;
  text-align: left;
  box-sizing: border-box;
}

.brand-logo-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  flex: 0 0 48px;
  overflow: hidden;
  border-radius: 3px;
  background: #f7f7f7;
}

.brand-logo-box img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.brand-name {
  min-width: 0;
  margin-left: 8px;
  color: #f5f5f5;
  font-size: 12px;
  font-weight: 400;
  line-height: 22px;
  word-break: break-word;
}

.section-panel {
  margin-top: 28px;
  padding: 22px 20px;
  border-radius: 12px;
  background: #222;
  box-sizing: border-box;
}

.section-title {
  margin: 0 0 20px;
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  line-height: 26px;
}

.vip-task-list {
  position: relative;
}

.vip-task-wrap {
  position: relative;
  margin-top: 14px;
}

.vip-task-wrap:first-child {
  margin-top: 0;
}

.vip-task-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 74px;
  padding: 16px;
  border: 0;
  border-radius: 8px;
  background: #1f1f1f;
  color: #fff;
  text-align: left;
  box-shadow: inset 0 0 0 1px #3b3b3b;
  box-sizing: border-box;
}

.vip-task-card-1 {
  background: linear-gradient(100deg, #8c15a6 0%, #5c0e7a 100%);
  box-shadow: none;
}

.vip-task-card-2 {
  background: linear-gradient(100deg, #43b5f7 0%, #10e7f5 100%);
  box-shadow: none;
}

.vip-task-card-3 {
  background: linear-gradient(100deg, #ff7c98 0%, #ffdb3f 100%);
  box-shadow: none;
}

.vip-copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.vip-copy strong {
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  line-height: 20px;
}

.vip-copy em {
  margin-top: 10px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 13px;
  font-style: normal;
  line-height: 18px;
}

.vip-amount {
  margin-left: 12px;
  color: #ff493d;
  font-size:16px;
  font-weight: 800;
  line-height: 24px;
  white-space: nowrap;
}

.vip-task-card-1 .vip-amount {
  color: #ff5df2;
}

.vip-task-card-2 .vip-amount,
.vip-task-card-3 .vip-amount {
  color: #ff3c32;
}

.vs-badge {
  position: absolute;
  left: 50%;
  bottom: -18px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(180deg, #8877f2 0%, #644ec1 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  transform: translateX(-50%);
}

.earnings-viewport {
  position: relative;
  height: 468px;
  overflow: hidden;
}

.earnings-track {
  display: flex;
  flex-direction: column;
  gap: 24px;
  animation: earnings-scroll 28s linear infinite;
  will-change: transform;
}

.earnings-viewport.is-static {
  height: auto;
  overflow: visible;
}

.earnings-viewport.is-static .earnings-track {
  animation: none;
}

.earning-row {
  display: flex;
  align-items: center;
  min-width: 0;
  flex-shrink: 0;
}

.earning-avatar {
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  border-radius: 50%;
  object-fit: cover;
  background: #111;
}

.earning-copy {
  min-width: 0;
  flex: 1;
  margin-left: 14px;
}

.earning-copy strong,
.earning-copy span {
  display: block;
  overflow: hidden;
  color: #f4f4f4;
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.earning-copy span {
  font-weight: 600;
}

.earning-amount {
  margin-left: 12px;
  color: #f4f4f4;
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
  white-space: nowrap;
}

@keyframes earnings-scroll {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-50%);
  }
}

.partners-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.partner-card {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
  padding: 8px;
  border: 0;
  border-radius: 8px;
  background: #f6f6f6;
  box-sizing: border-box;
}

.partner-card img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.dialog-img {
  display: block;
  width: 100%;
}

.popup {
  max-height: 60vh;
  padding: 22px;
  overflow-y: auto;
  color: #333;
  font-size: 14px;
  line-height: 20px;
}

/deep/ .site-notice-dialog {
  overflow: hidden;
  border-radius: 14px;
  background: #222;
  color: #f6f6f6;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.48);
}

/deep/ .site-notice-dialog .van-dialog__header {
  padding: 24px 24px 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  line-height: 22px;
  text-align: center;
}

/deep/ .site-notice-dialog .van-dialog__content {
  padding: 0 24px 22px;
  background: #222;
}

/deep/ .site-notice-dialog .van-dialog__footer {
  height: 50px;
  background: linear-gradient(90deg, #6479ea 0%, #8b55c6 100%);
  border-radius: 0 0 14px 14px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12);
}

/deep/ .site-notice-dialog .van-dialog__footer::after {
  border-width: 0;
}

/deep/ .site-notice-dialog .van-dialog__confirm {
  height: 50px;
  border-radius: 0 0 14px 14px;
  background: transparent;
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  line-height: 50px;
}

.site-notice-time {
  margin-bottom: 16px;
  color: rgba(255, 255, 255, 0.64);
  font-size: 12px;
  line-height: 18px;
  text-align: center;
}

.site-notice-body {
  max-height: 54vh;
  overflow-y: auto;
  color: #f6f6f6;
  font-size: 12px;
  font-weight: 600;
  line-height: 28px;
  word-break: break-word;
}

/deep/ .site-notice-body p {
  margin: 0 0 10px;
}

/deep/ .site-notice-body img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

/deep/ .van-swipe__indicators {
  bottom: 8px;
}

/deep/ .van-swipe__indicator {
  width: 8px;
  height: 8px;
  background-color: rgba(255, 255, 255, 0.52);
  opacity: 1;
}

/deep/ .van-swipe__indicator--active {
  background-color: #fff;
}

@media screen and (max-width: 374px) {
  .home-top {
    padding-right: 14px;
    padding-left: 14px;
  }

  .language {
    min-width: 126px;
  }

  .language-label {
    max-width: 66px;
  }

  .notice-card,
  .brand-panel {
    margin-right: 14px;
    margin-left: 14px;
  }

  .section-panel {
    padding-right: 16px;
    padding-left: 16px;
  }

  .brand-item {
    padding: 10px;
  }

  .brand-logo-box {
    width: 44px;
    height: 44px;
    flex-basis: 44px;
  }

  .brand-name {
    font-size: 13px;
  }
}
</style>
